import { Link } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";
import { useAcessoInstituicao } from "./api";
import { StatusBadge } from "./componentes";
import { DIAS_PADRAO, formatAcesso, formatDiasSemAcesso, formatNumero, periodoDosDias } from "./formato";

/** Bloco "Acessos" da ficha da instituição: status, último acesso e link para o detalhe. */
export function AcessosFicha({ idInstituicao }: { idInstituicao: number }) {
  const { data, isLoading } = useAcessoInstituicao(idInstituicao, periodoDosDias(DIAS_PADRAO));

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-border bg-card p-4 shadow-card">
      {isLoading ? (
        <Skeleton className="h-10 w-full" />
      ) : data ? (
        <>
          <div className="space-y-1 text-sm">
            <div className="flex items-center gap-2">
              <span className="font-semibold text-foreground">Acessos</span>
              <StatusBadge status={data.status} tipo="instituicao" />
            </div>
            <p className="text-muted-foreground">
              Último acesso {formatAcesso(data.ultimoAcesso)}
              {data.ultimoAcessoUsuario && ` por ${data.ultimoAcessoUsuario}`}
              {data.diasSemAcesso != null && data.diasSemAcesso > 1 && ` (${formatDiasSemAcesso(data.diasSemAcesso)})`} ·{" "}
              {formatNumero(data.logins)} logins e {data.usuariosAcessaram} de {data.usuariosAtivos} usuários nos últimos {DIAS_PADRAO} dias
            </p>
          </div>
          <Link to={`/Acessos/Instituicao/${idInstituicao}`} className="text-sm font-medium text-primary hover:underline">
            Ver frequência de acessos
          </Link>
        </>
      ) : (
        <p className="text-sm text-muted-foreground">Acessos indisponíveis.</p>
      )}
    </div>
  );
}
